"use client";
import React from "react";
import { ViewAllButton } from "@/components/common/ViewAllButton";

interface SectionTitleProps {
  blueText: string;
  blackText: string;
  // 전체 문자열 내에 <blue>...</blue> 마크업을 포함해 임의 위치/다중 태그를 지원합니다.
  titleHtml?: string;
  showViewAll?: boolean;
  viewAllHref?: string;
  viewAllPublicAccess?: boolean;
  onViewAllClick?: () => void;
  viewAllVariant?: "text" | "arrows";
  // arrows variant 전용 props
  onPrevious?: () => void;
  onNext?: () => void;
  canPrevious?: boolean;
  canNext?: boolean;
}

function renderTitleNodesForSection(titleHtml: string) {
  const parts = String(titleHtml).split(/(<blue>[\s\S]*?<\/blue>)/gi).filter(Boolean);
  return parts.map((part, idx) => {
    const m = part.match(/^<blue>([\s\S]*?)<\/blue>$/i);
    if (m) {
      return (
        <div key={idx} className="flex flex-col justify-center relative shrink-0 text-[#0248fd]">
          <p className="font-semibold leading-[normal] text-nowrap whitespace-pre text-xl lg:text-[32px]">{m[1]}</p>
        </div>
      );
    }
    return (
      <div key={idx} className="flex flex-col justify-center relative shrink-0 text-[#010103]">
        <p className="font-semibold leading-[normal] text-nowrap whitespace-pre text-xl lg:text-[32px]">{part}</p>
      </div>
    );
  });
}

export function SectionTitle({ blueText, blackText, titleHtml, showViewAll = true, viewAllHref, viewAllPublicAccess, onViewAllClick, viewAllVariant, onPrevious, onNext, canPrevious, canNext }: SectionTitleProps) {
  return (
    <div className="gap-2.5 grid grid-cols-[1fr_auto] grid-rows-[repeat(1,_minmax(0px,_1fr))] h-auto lg:h-[45px] overflow-clip relative shrink-0 w-full">
      <div className="content-stretch flex font-['Pretendard:Medium',_sans-serif] items-center justify-start leading-[0] not-italic overflow-clip relative shrink-0 text-xl lg:text-[32px] text-nowrap">
        {typeof titleHtml === 'string' && titleHtml.length > 0 ? (
          <>
            {renderTitleNodesForSection(titleHtml)}
          </>
        ) : (
          <>
            <div className="flex flex-col justify-center relative shrink-0 text-[#0248fd]">
              <p className="font-semibold leading-[normal] text-nowrap whitespace-pre">{blueText}</p>
            </div>
            <div className="flex flex-col justify-center relative shrink-0 text-[#010103]">
              <p className="font-semibold leading-[normal] text-nowrap whitespace-pre">{blackText}</p>
            </div>
          </>
        )}
      </div>
      {showViewAll && (
        <div className="content-stretch flex gap-[15px] items-center justify-end relative shrink-0">
          <ViewAllButton 
            href={viewAllHref} 
            publicAccess={viewAllPublicAccess} 
            onClick={onViewAllClick} 
            variant={viewAllVariant}
            onPrevious={onPrevious}
            onNext={onNext}
            canPrevious={canPrevious}
            canNext={canNext}
          />
        </div>
      )}
    </div>
  );
}

